import { defineStore } from "pinia";
export const useLoginStore = defineStore("loginStore", {
  state: () => ({
    user: {},
    appScopes: [],
    loggedIn: false,
    deviceOnline: false,
    peerId: null,
    peerName: '',
    pastLogging: false,
    selectedTheme: 'dark',
    subscriptionType: 'free', // 'free', 'device'
  }),
  getters: {
    getUser(state) {
      return state.user;
    },
    getAppScopes(state) {
      return state.appScopes;
    },
    getLoggedIn(state) {
      return state.loggedIn;
    },
    getDeviceOnline(state){
      return state.deviceOnline
    },
    getPeerId(state){
      return state.peerId
    },
    getPeerName(state){
      return state.peerName
    },
    getPastLogging(state){
      return state.pastLogging
    },
    getSelectedTheme(state){
      return state.selectedTheme
    },
    getSubscriptionType(state){
      return state.subscriptionType
    },
    hasDeviceSubscription(state){
      return state.subscriptionType === 'device'
    },
    isFreeTier(state){
      return state.subscriptionType === 'free'
    }
  },
  actions: {
    setUser(user) {
      this.user = user;
    },
    setAppScopes(appScopes) {
      this.appScopes = appScopes;
    },
    setLoggedIn(loggedIn) {
      this.loggedIn = loggedIn;
    },
    logOut(){
      this.user = {}
      this.appScopes = []
      this.loggedIn = false
      this.peerId = null
      this.subscriptionType = 'free'
      //this.pastLogging = false
      // Note: selectedTheme is NOT cleared on logout as per requirements
    },
    setDeviceOnline(deviceOnline){
      this.deviceOnline = deviceOnline
    },
    setPeerId(peerId){
      this.peerId = peerId
    },
    setPeerName(peerName){
      this.peerName = peerName
    },
    setPastLogging(pastLogging){
      this.pastLogging = pastLogging
    },
    setSelectedTheme(theme){
      if (theme === 'dark' || theme === 'light') {
        this.selectedTheme = theme
      }
    },
    setSubscriptionType(subscriptionType){
      // Convert incoming subscription types to lowercase format expected by the system
      const typeMap = {
        'Free': 'free',
        'Device': 'device',
        'Paid': 'device', // Legacy 'Paid' maps to 'device' for backward compatibility
        'Paid with Device': 'device', // Legacy 'Paid with Device' maps to 'device'
        'free': 'free',
        'device': 'device',
        'paid': 'device', // Legacy 'paid' maps to 'device'
        'paid_with_device': 'device' // Legacy 'paid_with_device' maps to 'device'
      }
      
      if (typeMap[subscriptionType]) {
        this.subscriptionType = typeMap[subscriptionType]
      }
    },
  },
  persist: true,
});
